import React from 'react';

const SelectArrow = () => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.4211 3H0.578825C0.0657524 3 -0.195624 3.61956 0.172239 3.98743L5.59339 9.40862C5.81604 9.63128 6.1839 9.63128 6.40665 9.40862L11.8278 3.98743C12.1956 3.61956 11.9342 3 11.4211 3Z"
                fill="#333333"
            />
        </svg>
    );
};

export default SelectArrow;
